import axios from "axios";
import {getToken} from "./TokenRepository";

const createConfig = () => {
    return {
        headers: {
            'Api-Key': `Bearer ${getToken()}`
        },
    };
}

export const accessLevels = [
    {value: 0, title: 'No access'},
    {value: 1, title: 'Read only'},
    {value: 2, title: 'Read write'},
    {value: 3, title: 'Grant only'},
];

export const getAccessLevelTitle = (accessLevel) =>
    accessLevels.find(x => x.value === accessLevel)?.title ?? `Unknown (${accessLevel})`;

export const getAccess2Accesses = async (managerUserId) => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/access2access/${managerUserId}`, createConfig());
    return response.data;
}

export const createAccess2Access = async (entry) => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/access2access`, {
        managerUserId: entry.managerUserId,
        userId: entry.userId,
        serviceId: entry.serviceId,
        accessLevel: entry.accessLevel
    }, createConfig());
    return response.data;
}

export const setAccess2AccessLevel = async (entry, accessLevel) => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/access2access/setAccessLevel`, {
        managerUserId: entry.managerUserId,
        userId: entry.userId,
        serviceId: entry.serviceId,
        accessLevel
    }, createConfig());
    return response.data;
}

export const deleteAccess2Access = async (entry) => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/access2access/delete`, {
        managerUserId: entry.managerUserId,
        userId: entry.userId,
        serviceId: entry.serviceId
    }, createConfig());
    return response.data;
}

export const getSearchableUsers = async () => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/searchable/users`, createConfig());
    return response.data;
}

export const getSearchableServices = async () => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/searchable/services`, createConfig());
    return response.data;
}
